import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";

export default {
    async stateList(): Promise<types.ResBoardStateList> {
        const res = {} as types.ResBoardStateList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/state/list", {}, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },
    async list(idx: number, param: types.ReqBoardActionList): Promise<types.ResBoardActionList> {
        const res = {} as types.ResBoardActionList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/action/list/${idx}`, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },

    async stateDetail(idx: number): Promise<types.ResBoardStateDetail> {
        const res = {} as types.ResBoardStateDetail;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/action/state/${idx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },
    async detail(idx: number): Promise<types.ResBoardAction> {
        const res = {} as types.ResBoardAction;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/detail/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },

    async confirmPw(param: types.ReqConfirmPw): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/confirm/pw", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },

    async confirmDetail(param: types.ReqConfirmPw): Promise<types.ResBoardAction> {
        const res = {} as types.ResBoardAction;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/confirm/detail", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },

    async add(stateIdx: number, param: types.ReqBoardAction): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(`/board/action/add/${stateIdx}`, formData, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },

    async modify(idx: number, param: types.ReqBoardAction): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/action/modify/" + idx, formData, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },

    async remove(param: types.ReqIdxList): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/remove", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },

    async removeForFile(idx: number, fileIdx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/file/remove/" + idx + fileIdx, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            Object.assign(res, error.response.data);
        }
        return res;
    },

    async exportExcel(param: types.ReqBoardActionForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/board/action/export/excel", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
